module.exports = "<rb-header ng-if=\"$ctrl.user\" />\n<rb-guest-header ng-if=\"!$ctrl.user\" />\n";